/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import { Box, Grid } from '@mui/material'
import { useStyles } from '../CaseDiagnosisStyles'
import Comment from './Comment'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { addListData, setSaveState } from '../../../actions'

export default function ReportBuilder({ location, pseudoProcedureCode }): JSX.Element | null {
  const classes = useStyles()
  const dispatch = useDispatch()
  const reportOptions = useSelector((state: RootState) => state.setCaseDiagnosis)
  const [currentReportOptions, setCurrentReportOptions] = useState([] as any)
  const getDraftReportData = useSelector((state: RootState) => state.setDraftReportData)
  const saveState = useSelector((state: RootState) => state.getSaveState)

  useEffect(() => {
    if (reportOptions && reportOptions.payload && reportOptions.payload.length && pseudoProcedureCode != '') {
      const procedureCodeReportOptions = reportOptions.payload.filter(
        (procObject) => procObject.procedureCode === pseudoProcedureCode,
      )
      if (procedureCodeReportOptions.length && procedureCodeReportOptions[0].reportOptions) {
        setCurrentReportOptions(procedureCodeReportOptions[0].reportOptions)
      }
    }
  }, [reportOptions, pseudoProcedureCode])

  useEffect(() => {
    const savedComments = [] as any
    if (getDraftReportData && getDraftReportData.reportBuilder && getDraftReportData.reportBuilder[location]) {
      const parentOptions = getDraftReportData.reportBuilder[location]
      Object.keys(parentOptions).map((key) => {
        const currentOptions = parentOptions[key]
        if (currentOptions && currentOptions.length && Array.isArray(currentOptions)) {
          currentOptions.map((commentItem) => {
            savedComments.push(commentItem)
          })
        }
      })
    }
    dispatch(addListData(savedComments, true))
    dispatch(setSaveState({ isSaveDisabled: true }))
  }, [location, getDraftReportData])

  return (
    <>
      <Box
        style={{
          boxSizing: 'border-box',
          boxShadow: '3px 0px 6px 0px rgba(0, 0, 0, 0.13)',
          backgroundColor: '#fff',
          height: '100%',
        }}
      >
        <Box className={classes.reportBuilder}>
          <div className={classes.reportBuilderTitle}>Report Comments</div>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            style={{ overflowY: 'visible', marginTop: '0px' }}
          >
            <div className={classes.reportBuilderWrapper}>
              {currentReportOptions &&
                currentReportOptions.length && //Object.keys(currentReportOptions)
                currentReportOptions.map((reportItem) => {
                  return (
                    <div className={classes.section}>
                      <Accordion>
                        <AccordionSummary
                          sx={{ backgroundColor: 'rgba(146, 187, 204, 0.55)' }}
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <div className={classes.sectionTitle}>{reportItem.category}</div>
                        </AccordionSummary>
                        {reportItem.children && reportItem.children.length && (
                          <AccordionDetails>
                            <div className={classes.diagnosisCommentsContainer}>
                              <div>
                                {reportItem.children.map((childComment, index) => {
                                  return (
                                    <Comment
                                      location={location}
                                      childComment={childComment}
                                      key={index}
                                      commentType={reportItem.category}
                                    />
                                  )
                                })}
                              </div>
                            </div>
                          </AccordionDetails>
                        )}
                      </Accordion>
                    </div>
                  )
                })}
            </div>
          </Grid>
        </Box>
      </Box>
    </>
  )
}
